import React from 'react';
import { Link } from 'react-router-dom'
import { Layout, Card, Row, Col, Button, Carousel, Divider, Skeleton, Empty, Spin } from 'antd'
import { DribbbleOutlined, StopOutlined, StopFilled, DribbbleCircleFilled } from '@ant-design/icons'
const { Content } = Layout;
import { checkMobile } from '../../../comonFunction/utils'
const isMobile = checkMobile()
import MainContentSider from '../../general/MainContentSider'
import MainContentSright from '../../general/MainContentSright' 
import Slider from './Slider'
import ServerApi from '../../../utils/ServerApi'
import appConst from '../../../constents/app.const'
import api_url from '../../../utils/requestApi'

class Upcoming extends React.Component {
    constructor(props){
        super(props)
        this.work_data_fetch = this.work_data_fetch.bind(this)
        this.notifications = this.notifications.bind()
    }
    state = {
        isMobile: '',
        data_c: [],
        data_f: [],
        data_t: [],
        data_v: [],
        loading_c: true,
        loading_f: true,
        loading_t: true,
        loading_v: true,
        hasMore: true,
        loading: true,
        notice_l: []
    }
    componentDidMount(){
        this.work_data_fetch()
        this.notifications()
    }
    notifications = () => {
      const serverApi = new ServerApi(appConst.apiUrl, this.props.token)
      serverApi.club_fetch(api_url.notice, returnData => {
        if(returnData.success == '1'){
          this.setState({notice_l: returnData.notice})
        }
      })
    }
    work_data_fetch = () => {
        const serverApi = new ServerApi(appConst.apiUrl, null)
        serverApi.work_data(api_url.work_c_upcoming, returnData => {
            if(returnData.success == '1'){
                this.setState({
                loading_c: false,
                data_c: returnData.data
                })
            }else{
                this.setState({
                    loading_c: true,
                    data_c: []
                })
            }
        })
        serverApi.work_data(api_url.work_f_upcoming, returnData => {
            if(returnData.success == '1'){
                this.setState({
                loading_f: false,
                data_f: returnData.data
                })
            }else{
                this.setState({
                    loading_f: true,
                    data_f: []
                })
            }
        })
        serverApi.work_data(api_url.work_t_upcoming, returnData => {
            if(returnData.success == '1'){
                this.setState({
                loading_t: false,
                data_t: returnData.data
                })
            }else{
                this.setState({
                    loading_t: true,
                    data_t: []
                })
            }
        })
        serverApi.work_data(api_url.work_v_upcoming, returnData => {
            if(returnData.success == '1'){
                this.setState({
                    loading_v: false,
                    data_v: returnData.data,
                    loading: false
                })
            }else{
                this.setState({
                    loading_v: true,
                    data_v: []
                })
            }
        })
    }
    empty_work = (
      <Card size="small">
        <Empty
          image={Empty.PRESENTED_IMAGE_SIMPLE}
          imageStyle={{height: '40px'}}
          description="Empty Match"
        />
      </Card>
    )
    render(){
        const onChange = (currentSlide) => {
          //console.log(currentSlide);
        }
        return(
            <Content>
                <div
                    style={{
                        minHeight: '90vh',
                        background: '#23370D',
                    }}
                >
                    <Row>
                        <Col xs={0} sm={0} md={0} lg={4} xl={4} style={{padding: '0px 3px 0px 3px'}}>
                            {/* <Card 
                                style={{borderRadius: '0px'}}
                                className=''
                                bordered={true}
                                hoverable={false}
                            >
                                <MainContentSider />
                            </Card> */}
                        </Col>
                        <Col xs={24} sm={24} md={24} lg={14} xl={14}>
                            <Spin tip="Upcoming..." spinning={this.state.loading} size="large" style={{color: 'black', fontSize: '15px', fontWeight: 'bold'}}>
                                <div style={{marginBottom: '3px'}}>
                                    <Carousel
                                        afterChange={onChange}
                                        dotPosition="bottom"
                                        dots={false}
                                        autoplay
                                        effect="fade"
                                    >
                                        {this.state.notice_l.map((notice, index) => {
                                            return(
                                                <div key={index}>
                                                <div className="notification-mutli-div" dangerouslySetInnerHTML={{__html: notice.text}}></div>
                                                </div>
                                            )
                                        })}
                                    </Carousel>
                                    {/* <Slider /> */}
                                    <div className="after-ant-anchor-header-div">
                                        {this.state.loading_c==false?(
                                        <>
                                            {/* {this.state.data_c.length > 0?<Divider orientation="left" dashed style={{height: '10px', fontSize: '13px'}}><StopFilled /> Cricket - Upcoming</Divider>:''} */}
                                            {this.state.data_c.length > 0?this.state.data_c.map((work, index) => {
                                                return(
                                                    <div key={index}>
                                                    <Link to={"/pot single page?id="+work.id+"&type=c_work"}>
                                                        <Card hoverable={true} bordered={true} size="small" className="pot-single-div">
                                                            <Row>
                                                                <Col span={3}><img className="logo-title-m" src="./img/game/cricket.png" width="30"/></Col>
                                                                <Col span={21}>
                                                                <span style={{fontSize: '16px'}}><span>{work.team1+' '}</span><span className="title-vs">vs</span><span>{' '+work.team2}</span></span><br/>
                                                                <span style={{fontSize: '12px'}}>{work.title +' || '+work.date}</span>
                                                                </Col>
                                                            </Row>
                                                        </Card>
                                                    </Link>
                                                    </div>
                                                )
                                            }):''}
                                        </>
                                        ):(
                                        <>
                                            <Card hoverable={true} bordered={true}>
                                            <Skeleton active />
                                            </Card>
                                            <Card hoverable={true} bordered={true}>
                                            <Skeleton active />
                                            </Card>
                                        </>
                                        )}
                                        {this.state.loading_f==false?(
                                        <>
                                            {/* {this.state.data_f.length > 0?<Divider orientation="left" dashed style={{height: '10px', fontSize: '13px'}}><DribbbleCircleFilled /> Football - Upcoming</Divider>:''} */}
                                            {this.state.data_f.length > 0?this.state.data_f.map((work, index) => {
                                                return(
                                                    <div key={index}>
                                                    <Link to={"/pot single page?id="+work.id+"&type=f_work"}>
                                                        <Card hoverable={true} bordered={true} size="small" className="pot-single-div">
                                                            <Row>
                                                                <Col span={3}><img className="logo-title-m" src="./img/game/football.png" width="30"/></Col>
                                                                <Col span={21}>
                                                                <span style={{fontSize: '16px'}}><span>{work.team1+' '}</span><span className="title-vs">vs</span><span>{' '+work.team2}</span></span><br/>
                                                                <span style={{fontSize: '12px'}}>{work.title +' || '+work.date}</span>
                                                                </Col>
                                                            </Row>
                                                        </Card>
                                                    </Link>
                                                    </div>
                                                )
                                            }):''}
                                        </>
                                        ):(
                                        <>
                                            <Card hoverable={true} bordered={true}>
                                            <Skeleton active />
                                            </Card>
                                            <Card hoverable={true} bordered={true}>
                                            <Skeleton active />
                                            </Card>
                                        </>
                                        )}
                                        {this.state.loading_t==false?(
                                        <>
                                            {/* {this.state.data_t.length > 0?<Divider orientation="left" dashed style={{height: '10px', fontSize: '13px'}}><StopOutlined /> Tennis - Upcoming</Divider>:''} */}
                                            {this.state.data_t.length > 0?this.state.data_t.map((work, index) => {
                                                return(
                                                    <div key={index}>
                                                    <Link to={"/pot single page?id="+work.id+"&type=t_work"}>
                                                        <Card hoverable={true} bordered={true} size="small" className="pot-single-div">
                                                            <Row>
                                                                <Col span={3}><img className="logo-title-m" src="./img/game/tennis.png" width="30"/></Col>
                                                                <Col span={21}>
                                                                <span style={{fontSize: '16px'}}><span>{work.team1+' '}</span><span className="title-vs">vs</span><span>{' '+work.team2}</span></span><br/>
                                                                <span style={{fontSize: '12px'}}>{work.title +' || '+work.date}</span>
                                                                </Col>
                                                            </Row>
                                                        </Card>
                                                    </Link>
                                                    </div>
                                                )
                                            }):''}
                                        </>
                                        ):(
                                        <>
                                            <Card hoverable={true} bordered={true}>
                                            <Skeleton active />
                                            </Card>
                                            <Card hoverable={true} bordered={true}>
                                            <Skeleton active />
                                            </Card>
                                        </>
                                        )}
                                        {this.state.loading_v==false?(
                                        <>
                                            {/* {this.state.data_v.length > 0?<Divider orientation="left" dashed style={{height: '10px', fontSize: '13px'}}><DribbbleOutlined /> Table Tannis - Upcoming</Divider>:''} */}
                                            {this.state.data_v.length > 0?this.state.data_v.map((work, index) => {
                                                return(
                                                    <div key={index}>
                                                    <Link to={"/pot single page?id="+work.id+"&type=v_work"}>
                                                        <Card hoverable={true} bordered={true} size="small" className="pot-single-div">
                                                            <Row>
                                                                <Col span={3}><img className="logo-title-m" src="./img/game/table_tennis.png" width="30"/></Col>
                                                                <Col span={21}>
                                                                <span style={{fontSize: '16px'}}><span>{work.team1+' '}</span><span className="title-vs">vs</span><span>{' '+work.team2}</span></span><br/>
                                                                <span style={{fontSize: '12px'}}>{work.title +' || '+work.date}</span>
                                                                </Col>
                                                            </Row>
                                                        </Card>
                                                    </Link>
                                                    </div>
                                                )
                                            }):''}
                                        </>
                                        ):(
                                        <>
                                            <Card hoverable={true} bordered={true}>
                                            <Skeleton active />
                                            </Card>
                                            <Card hoverable={true} bordered={true}>
                                            <Skeleton active />
                                            </Card>
                                        </>
                                        )}
                                    </div>
                                </div>
                            </Spin>
                        </Col>
                        <Col xs={0} sm={0} md={0} lg={6} xl={6} style={{padding: '0px 3px 0px 3px'}}>
                            {/* <MainContentSright /> */}
                        </Col>
                    </Row>
                </div>
            </Content>
        )
    }
}

export default Upcoming;